import { ActionReducerMapBuilder } from "@reduxjs/toolkit";

import { getUserCurrentLocation } from "../operations/getUserCurrentLocation";

import { STATUS_LOADING } from "common/constants";
import { State } from "../types/state";

export const setUSerCurrentLocation = (
  builder: ActionReducerMapBuilder<State>
) =>
  builder
    .addCase(getUserCurrentLocation.pending, (state) => {
      state.currentLocation.loadingStatus = STATUS_LOADING.load;
    })
    .addCase(getUserCurrentLocation.fulfilled, (state, { payload }) => {
      state.currentLocation.loadingStatus = STATUS_LOADING.done;
      state.currentLocation.data = payload.usersLocations;
    })
    .addCase(getUserCurrentLocation.rejected, (state) => {
      state.currentLocation.loadingStatus = STATUS_LOADING.error;
    });
